



















import { Vue, Component, Prop } from "vue-property-decorator";
import {
  COLOR_AI_PREDICTION_BAR_PRIMARY,
  COLOR_AI_PREDICTION_BAR_GREEN,
  COLOR_AI_PREDICTION_BAR_GREY,
  COLOR_AI_PREDICTION_BAR_TRACK,
} from "@/utils/colors";

/**
 * A horizontal bar showing probability (0–1) as a percentage.
 * Supports two modes:
 *  - Multi-class: bar shows the probability, with `isHighest` highlighting
 *  - Binary: bar colors by threshold (green ≥50%, red <50%)
 */
@Component
export default class ProbabilityBar extends Vue {
  /** Probability value between 0 and 1 */
  @Prop({ type: Number, required: true }) readonly probability!: number;

  /** Optional human-readable label */
  @Prop({ type: String, default: "" }) readonly label!: string;

  /** Whether this item is the highest probability in its group */
  @Prop({ type: Boolean, default: false }) readonly isHighest!: boolean;

  /** True for binary/boolean predictions (green/red coloring) */
  @Prop({ type: Boolean, default: false }) readonly isBinary!: boolean;

  get percentageWidth(): string {
    const pct = Math.max(0, Math.min(1, this.probability)) * 100;
    return `${pct}%`;
  }

  get formattedPercentage(): string {
    return `${(this.probability * 100).toFixed(1)}%`;
  }

  get barColorClass(): string {
    if (this.isBinary) {
      return this.probability >= 0.5 ? "bar-green" : "bar-grey";
    }
    return this.isHighest ? "bar-primary" : "bar-grey";
  }

  get barColor(): string {
    if (this.isBinary) {
      return this.probability >= 0.5 ? COLOR_AI_PREDICTION_BAR_GREEN : COLOR_AI_PREDICTION_BAR_GREY;
    }
    return this.isHighest ? COLOR_AI_PREDICTION_BAR_PRIMARY : COLOR_AI_PREDICTION_BAR_GREY;
  }

  get barStyle(): Record<string, string> {
    return {
      width: this.percentageWidth,
      backgroundColor: this.barColor,
    };
  }

  get trackStyle(): Record<string, string> {
    return {
      backgroundColor: COLOR_AI_PREDICTION_BAR_TRACK,
    };
  }
}
